module.exports = __webpack_public_path__ + "img/fcb-logo-ja.4cc1e77e.png";